import {
  FilterPreferenceRecognizedLists,
  UserContextPreferences,
} from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { Brand } from '../../../context/ApplicationContext/applicationContext.types';
import {
  ComputeVisibleSlotsParams,
  SelectVisibleBrandsParams,
  VisibleBrands,
} from './storeConnections.types';

export const RECENT_BRANDS_STORED_LIMIT = 10;

export const RECENT_BRANDS_CANDIDATES_LIMIT = 24;

export const BRAND_TILE_WIDTH = 96;

export const BRAND_TILE_AVATAR_SIZE = 56;

export const BRAND_TILE_GAP = 2;

export const getRecentBrandIds = (preferences?: UserContextPreferences | null): string[] => {
  const stored = preferences?.filterPreferences?.find(
    (preference) => preference.list === FilterPreferenceRecognizedLists.STORE_RECENT_BRANDS,
  )?.defaultFilters?.brandIds;

  return Array.isArray(stored) ? [...new Set(stored)] : [];
};

export const shouldRecordVisit = (recentIds: string[], brandId: string): boolean =>
  recentIds[0] !== brandId;

export const pushRecentBrandId = (recentIds: string[], brandId: string): string[] =>
  [brandId, ...recentIds.filter((id) => id !== brandId)].slice(0, RECENT_BRANDS_STORED_LIMIT);

const connectedAtTime = (brand: Brand) =>
  brand.connectedAt ? new Date(brand.connectedAt).getTime() : 0;

const byMostRecentConnection = (first: Brand, second: Brand) => {
  const difference = connectedAtTime(second) - connectedAtTime(first);
  return difference !== 0 ? difference : first.name.localeCompare(second.name);
};

export const orderBrandsForSelector = (brands: Brand[], recentIds: string[]): Brand[] => {
  const brandsById = new Map(brands.map((brand) => [brand.id, brand]));

  const visited = recentIds
    .map((id) => brandsById.get(id))
    .filter((brand): brand is Brand => Boolean(brand));

  const visitedIds = new Set(visited.map((brand) => brand.id));

  const remaining = brands
    .filter((brand) => !visitedIds.has(brand.id))
    .sort(byMostRecentConnection);

  return [...visited, ...remaining].slice(0, RECENT_BRANDS_CANDIDATES_LIMIT);
};

export const computeVisibleSlots = ({
  availableWidth,
  tileWidth,
  gap,
}: ComputeVisibleSlotsParams): number =>
  Math.max(1, Math.floor((availableWidth + gap) / (tileWidth + gap)));

export const selectVisibleBrands = ({
  brands,
  totalCount,
  slots,
}: SelectVisibleBrandsParams): VisibleBrands => {
  const hasTrailer = totalCount >= slots;

  return {
    visibleBrands: hasTrailer ? brands.slice(0, Math.max(1, slots - 1)) : brands,
    hasTrailer,
  };
};
